/* eslint-disable @angular-eslint/directive-selector */
/* eslint-disable @typescript-eslint/no-inferrable-types */

import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Output,
} from '@angular/core';

/**
 * This directive allows alphanumeric characters, spaces, hyphens, and underscores.
 */
@Directive({
  selector: '[modifiedAlphanumeric]',
})
export class ModifiedAlphaNumericDirective {
  private regex = new RegExp(/^([a-zA-Z0-9_-\s]+ ?)*$/);
  private antiRegex = new RegExp(/[^a-zA-Z\d\s_-]+/g);
  private specialRemoved: boolean;

  @Output() specialRemovedEmitter: EventEmitter<boolean> = new EventEmitter();

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInput(event: any) {
    const initialValue = event.target.value;
    this.el.nativeElement.value = initialValue.replace(
      /[^a-zA-Z0-9\s\-_]/g,
      '',
    );

    if (initialValue !== this.el.nativeElement.value) {
      event.target.value = initialValue.replace(/[^a-zA-Z0-9\s\-_]/g, '');
    }
  }
}
